import styled from 'styled-components';

export const VerticalSeparator = styled.div`
  height: 1.5rem;
`;

export const HorizontaSeparator = styled.div`
  width: 1rem;
`;